import Icon from '../../../components/AppIcon';
import DroneIcon from '../../../components/icons/DroneIcon';
import QuestionCard from './QuestionCard';

const ShootingMethodStep = ({ formData, onUpdate, isDirectMode, preselectedPhotographer }) => {
  // دعم اختيار واحد أو أكثر: القائمة المختارة مستمدة من formData لتبقى متزامنة عند الرجوع للخطوة
  const selectedList = Array.isArray(formData?.shootingMethods) && formData.shootingMethods.length > 0
    ? formData.shootingMethods
    : formData?.shootingMethod ? [formData.shootingMethod] : [];

  // Get photographer's available shooting methods
  const photographerMethods = preselectedPhotographer?.shootingMethods ||
                              preselectedPhotographer?.shooting_methods ||
                              [];

  const shootingMethods = [
    { value: 'professional_camera', label: 'كاميرا احترافية', description: 'تصوير احترافي بكاميرا عالية الجودة', icon: 'Camera', useDroneIcon: false },
    { value: 'mobile_camera', label: 'كاميرا جوال', description: 'تصوير بكاميرا الهاتف المحمول', icon: 'Smartphone', useDroneIcon: false },
    { value: 'drone', label: 'تصوير جوي (درون)', description: 'تصوير جوي باستخدام طائرة بدون طيار', icon: 'Radio', useDroneIcon: true }
  ];

  const handleMethodToggle = (value) => {
    if (isDirectMode && photographerMethods.length > 0 && !photographerMethods.includes(value)) return;
    const isSelected = selectedList.includes(value);
    const newArr = isSelected ? selectedList.filter((m) => m !== value) : [...selectedList, value];
    const labels = shootingMethods.filter((m) => newArr.includes(m.value)).map((m) => m.label);
    onUpdate({
      shootingMethods: newArr,
      shootingMethod: newArr[0] || '',
      shootingMethodLabels: labels,
      shootingMethodLabel: labels[0] || ''
    });
  };

  // Filter methods in direct mode
  const availableMethods = isDirectMode && photographerMethods.length > 0
    ? shootingMethods.filter(m => photographerMethods.includes(m.value))
    : shootingMethods;

  const isSelected = (value) => selectedList.includes(value);

  return (
    <QuestionCard
      icon="Video"
      title="بأي وسيلة ترغب أن يتم التصوير؟"
      description={isDirectMode && photographerMethods.length > 0
        ? "وسائل التصوير المتاحة من المصور المحدد — يمكنك اختيار وسيلة أو أكثر"
        : "اختر وسيلة أو أكثر من وسائل التصوير المناسبة لاحتياجاتك"
      }
    >
      {/* متاح فقط — مخفي من UI */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {availableMethods.map((method) => {
          const selected = isSelected(method.value);
          return (
            <button
              key={method.value}
              type="button"
              onClick={() => handleMethodToggle(method.value)}
              className={`p-5 rounded-xl border-2 text-right transition-all ${
                selected
                  ? 'border-primary bg-primary/10 shadow-sm'
                  : isDirectMode && photographerMethods.length > 0 && !photographerMethods.includes(method.value)
                  ? 'border-border bg-background opacity-50 cursor-not-allowed'
                  : 'border-border bg-background hover:border-primary hover:bg-primary/5'
              }`}
              disabled={isDirectMode && photographerMethods.length > 0 && !photographerMethods.includes(method.value)}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-600/10 to-blue-500/10 flex items-center justify-center flex-shrink-0 border border-blue-200/50">
                      {method.useDroneIcon ? (
                        <DroneIcon size={20} className="text-blue-600" />
                      ) : (
                        <Icon name={method.icon} size={20} className="text-blue-600" />
                      )}
                    </div>
                    <div>
                      <div className="text-base font-semibold text-foreground">
                        {method.label}
                      </div>
                      <div className="text-sm text-muted-foreground mt-1">
                        {method.description}
                      </div>
                    </div>
                  </div>
                </div>
                {selected && (
                  <Icon name="CheckCircle2" size={20} color="var(--color-primary)" className="flex-shrink-0" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </QuestionCard>
  );
};

export default ShootingMethodStep;
